import { render, staticRenderFns } from "./UsersWhoNeedTheMostTrainingChart.vue?vue&type=template&id=076f00fa&scoped=true"
import script from "../../../scripts/partials/dashboard-charts/UsersWhoNeedTheMostTrainingChart.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/UsersWhoNeedTheMostTrainingChart.js?vue&type=script&lang=js&external"
import style0 from "./UsersWhoNeedTheMostTrainingChart.vue?vue&type=style&index=0&id=076f00fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f00fa",
  null
  
)

export default component.exports